import React, { useState } from 'react';
import { FaSearch, FaTimes } from 'react-icons/fa';
import '../../styles/Files.css';

const SearchBar = ({ onSearch }) => {
  const [searchTerm, setSearchTerm] = useState('');
  
  const handleChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    onSearch(value);
  };
  
  const clearSearch = () => {
    setSearchTerm('');
    onSearch('');
  };
  
  return (
    <div className="search-container">
      <div className="search-bar">
        <FaSearch className="search-icon" />
        <input
          type="text"
          placeholder="Search your files..."
          value={searchTerm}
          onChange={handleChange}
        />
        {searchTerm && (
          <button className="clear-search" onClick={clearSearch}>
            <FaTimes />
          </button>
        )}
      </div>
    </div>
  );
};

export default SearchBar;